<template>
  <div id="app">
    <router-view/>
    <div @click="count" class="console"></div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      debugCount:0,
    }
  },
  methods:{
    count() {
      this.debugCount++;
      if (this.debugCount >= 6) {
        this.debugCount = 0
        if(localStorage.getItem("debug")){
          localStorage.removeItem('debug')
        }else{
          localStorage.setItem('debug','Y')
        }
        this.$toast.success("调试模式" + (localStorage.getItem("debug") === "Y" ? "开启" : "关闭"));
        window.location.reload()
      }
    }
  },
}
</script>

<style>
@import './assets/style/base.css';
@import './assets/style/elementUI.css';


.console{
  width: 50px;
  height:30px;
  /*background: #3A71A8;*/
  position: fixed;
  top:0px;
  right:0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue